import { useRef } from "react";

export default function Spotlight({ children, className = "" }) {
  const ref = useRef(null);

  const handlePointerMove = (event) => {
    const node = ref.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    node.style.setProperty("--mouse-x", `${event.clientX - rect.left}px`);
    node.style.setProperty("--mouse-y", `${event.clientY - rect.top}px`);
  };

  return (
    <div ref={ref} className={`spotlight ${className}`} onPointerMove={handlePointerMove}>
      {children}
    </div>
  );
}
